/* Common Imports */
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import AmenitiesIconCard from "./subcomponents/AmenitiesIconCard";

const useStyles = makeStyles((theme) => ({
  megaContainer: {
    width: "100%",
    margin: "0rem 0rem 6rem 0rem",
    [theme.breakpoints.down("xs")]: {
      margin: "0rem 0rem 3rem 0rem",
    },
  },
  sectionContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    gap: "0.5rem",
  },
  heading: {
    width: "100%",
    color: "#693471",
    fontWeight: 600,
    fontSize: "2.125rem",
    lineHeight: "2.65rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.25rem",
      lineHeight: "2rem",
    },
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  subHeading: {
    color: "#693471",
    fontWeight: "500",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    background: "-webkit-linear-gradient(180deg, #74378E 0%, #502761 100%)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  mainContainer: {
    padding: "0rem 8rem 0rem 8rem",
    margin: "2.5rem 0rem 2.5rem 0rem",
    [theme.breakpoints.down("lg")]: {
      padding: "0rem 2rem 0rem 2rem",
    },
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
  },
  cardContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    width: "100%",
    gap: "0.5rem",
    flexWrap: "wrap",
  },
  amenityCard: {
    width: "48%",
    padding: "1rem",
    borderRadius: "1rem",

    backgroundColor: "#F0EBF1",
    [theme.breakpoints.only("md")]: {
      width: "48%",
    },
    fill: "#693471",
    "& img": {
      width: "40px",
      height: "40px",
      fill: "#693471",
    },
    "& svg": {
      width: "40px",
      height: "40px",
      fill: "#693471",
    },
  },
  showMoreText: {
    color: "#693471",
    cursor: "pointer",
    fontWeight: "500",
    fontSize: "1rem",
    lineHeight: "1.5rem",
    textDecoration: "none",
    marginTop: "1rem",
  },
}));

const AmenitiesMobile = () => {
  const classes = useStyles();
  const [showAll, setShowAll] = React.useState(false);

  const amenities = [
    { title: "Gym", icon: "/images/icons/heavie/singleproperty/gym_mobile.svg" },
    { title: "Yoga Deck", icon: "/images/icons/heavie/singleproperty/yoga_mobile.svg" },
    { title: "Kids Play Area", icon: "/images/icons/heavie/singleproperty/kids_play_mobile.svg" },
    { title: "Party Counter", icon: "/images/icons/heavie/singleproperty/party_mobile.svg" },
    { title: "Barbeque Area", icon: "/images/icons/heavie/singleproperty/barbeque_mobile.svg" },
    { title: "Bonfire Area", icon: "/images/icons/heavie/singleproperty/bonfire_mobile.svg" },
    { title: "Infinity Pool", icon: "/images/icons/heavie/singleproperty/swimming_mobile.svg" },
    { title: "Meditation Zone", icon: "/images/icons/heavie/singleproperty/meditation_mobile.svg" },
    { title: "Kids Pool", icon: "/images/icons/heavie/singleproperty/kids_pool_mobile.svg" },
    { title: "Community Hall", icon: "/images/icons/heavie/singleproperty/community_mobile.svg" },
    { title: "Outdoor Lounge", icon: "/images/icons/heavie/singleproperty/outdoor_mobile.svg" },
    { title: "Security", icon: "/images/icons/heavie/singleproperty/security_mobile.svg" },
  ];

  const visibleAmenities = showAll ? amenities : amenities.slice(0, 4);

  return (
    <React.Fragment>
      <div className={classes.mainContainer}>
        <div className={classes.sectionContainer}>
          <Typography
            variant="h6"
            component="h6"
            className={classes.heading}
          >
            Amenities
          </Typography>
          <div className={classes.cardContainer}>
            {visibleAmenities.map((amenity, index) => (
              <AmenitiesIconCard
                key={index}
                title={amenity.title}
                icon={amenity.icon}
                className={classes.amenityCard}
              />
            ))}
          </div>
          <Typography
            variant="body1"
            component="span"
            className={classes.showMoreText}
            onClick={() => setShowAll(!showAll)}
          >
            {showAll ? "Show less amenities" : "+8 More amenities"}
          </Typography>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AmenitiesMobile;
